import React from 'react';

export default function Careers() {
  return (
    <div className="pt-32 pb-24 bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <h1 className="text-5xl font-serif text-slate-900 mb-6">Join Eldenwyck & Co.</h1>
          <p className="text-xl text-slate-600 font-light leading-relaxed">
            We are looking for exceptional minds who want to solve the world's most complex business problems.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {[
            { title: 'Consultants', desc: 'Work directly with industry leaders to drive strategic change.' },
            { title: 'Experts', desc: 'Apply deep technical or functional knowledge to niche challenges.' },
            { title: 'Students', desc: 'Kickstart your career with our world-class internship programs.' }
          ].map((role, i) => (
            <div key={i} className="p-8 border border-slate-100 bg-slate-50 hover:border-amber-600 transition-colors">
              <h3 className="text-xl font-serif font-bold mb-4">{role.title}</h3>
              <p className="text-slate-600 mb-6">{role.desc}</p>
              <button className="text-amber-600 font-bold text-sm uppercase tracking-widest">Learn More</button>
            </div>
          ))}
        </div>

        <div className="relative h-96 overflow-hidden">
          <img 
            src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=1200" 
            className="w-full h-full object-cover"
            alt="Office Life"
          />
          <div className="absolute inset-0 bg-slate-900/40 flex items-center justify-center">
            <div className="text-center text-white p-8">
              <h2 className="text-3xl font-serif mb-4">A Culture of Excellence</h2>
              <p className="max-w-xl mx-auto">We foster an environment where diversity of thought leads to breakthrough solutions.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}